import { AGENCY_UPDATESTATUS_INIT_LOADING, AGENCY_UPDATESTATUS_INIT_SUCCESS, AGENCY_UPDATESTATUS_INIT_FAIL } from '@/store/types'

export const updateStatus = {
  [AGENCY_UPDATESTATUS_INIT_LOADING](state) {
    state.updateStatus.init = 0
    state.updateStatus.initErr = []
    state.updateStatus.menu = {}
    state.updateStatus.statusList = []
  },
  [AGENCY_UPDATESTATUS_INIT_SUCCESS](state, data) {
    state.updateStatus.init = 1
    state.updateStatus.initErr = []
    state.updateStatus.menu = data.menu
    state.updateStatus.statusList = data.statusList
  },
  [AGENCY_UPDATESTATUS_INIT_FAIL](state, error) {
    state.updateStatus.init = 2
    state.updateStatus.initErr = error
    state.updateStatus.menu = {}
    state.updateStatus.statusList = []
  }
}
